import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useSettings } from "@/hooks/useSiteData";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

export const PublicLayout = () => {
  const { data: settings } = useSettings();
  const wa = settings?.whatsapp ? `https://wa.me/${settings.whatsapp}?text=${encodeURIComponent("Hello Jonaren Technology, I would like to discuss a project.")}` : null;
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <ScrollToTop />
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      {wa && (
        <a href={wa} target="_blank" rel="noopener noreferrer" aria-label="Chat with us on WhatsApp" data-testid="floating-whatsapp-button"
          className="fixed bottom-5 right-5 z-40 inline-flex h-13 w-13 items-center justify-center rounded-full bg-[#25D366] p-3.5 text-white shadow-lg transition-transform duration-200 hover:scale-105 lg:hidden" style={{ paddingBottom: "calc(0.875rem + env(safe-area-inset-bottom, 0px) / 2)" }}>
          <MessageCircle className="h-6 w-6" />
        </a>
      )}
    </div>
  );
};
